var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import { sanitizeBaseUrl } from "../../../utils";
import { assignReferrer, getProfile, getUsersPublicDomainConfiguration, verifyReferralCode, } from "../../evo-client/__generated__";
import { createClient, createConfig } from "../../evo-client/__generated__/client";
export class ReferralApiEvo {
    constructor(baseUrl, tenantToken, recaptchaId) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    static init() {
        const { EVO_DOMAIN, EVO_TENANT, "X-RECAPTCHA-ID": recaptchaId } = getConfig();
        return new ReferralApiEvo(EVO_DOMAIN, EVO_TENANT, recaptchaId);
    }
    getCustomer(uuid, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const EMPTY_CUSTOMER = {
                id: "",
                uuid: "",
                code: "",
                parent_code: "",
                tenant_code: "",
                has_first_purchase: null,
            };
            const { data } = yield getProfile({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": ciam_token,
                },
                path: {
                    uuid,
                },
            });
            if (!((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.consumer)) {
                return EMPTY_CUSTOMER;
            }
            const { consumer } = data.data;
            return {
                id: "",
                tenant_code: "",
                uuid: consumer === null || consumer === void 0 ? void 0 : consumer.uuid,
                code: consumer === null || consumer === void 0 ? void 0 : consumer.referral_code,
                parent_code: consumer === null || consumer === void 0 ? void 0 : consumer.parent_code,
                has_first_purchase: consumer === null || consumer === void 0 ? void 0 : consumer.has_first_referrer_purchase,
            };
        });
    }
    getStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data } = yield getUsersPublicDomainConfiguration({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
            });
            return Boolean((_a = data === null || data === void 0 ? void 0 : data.referrals) === null || _a === void 0 ? void 0 : _a.enabled);
        });
    }
    verifyCode(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const UNPROCESSABLE_ENTITY_STATUS = 422;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { error, response } = yield verifyReferralCode({
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                throwOnError: false,
                client: this.client,
                path: {
                    code,
                },
            });
            if (!response.ok) {
                if (response.status === UNPROCESSABLE_ENTITY_STATUS) {
                    return false;
                }
                throw error;
            }
            return true;
        });
    }
    getReferralStats(uuid, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const EMPTY_STATS = {
                referees_count: 0,
                completed_first_order_count: 0,
                earned_points: 0,
            };
            try {
                const { data } = yield getProfile({
                    client: this.client,
                    headers: {
                        "X-DES-TENANT": this.tenantToken,
                        "X-DES-USER-TOKEN": ciam_token,
                    },
                    path: {
                        uuid,
                    },
                });
                if (!((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.referrer_statistics)) {
                    return EMPTY_STATS;
                }
                const { referrer_statistics } = data.data;
                return {
                    completed_first_order_count: (_b = referrer_statistics.completed_first_order_count) !== null && _b !== void 0 ? _b : EMPTY_STATS.completed_first_order_count,
                    earned_points: (_c = referrer_statistics.earned_points) !== null && _c !== void 0 ? _c : EMPTY_STATS.earned_points,
                    referees_count: (_d = referrer_statistics.referrals_count) !== null && _d !== void 0 ? _d : EMPTY_STATS.referees_count,
                };
            }
            catch (e) {
                return EMPTY_STATS;
            }
        });
    }
    updateReferralCode(uuid, referrer_code, ciam_token, source) {
        return __awaiter(this, void 0, void 0, function* () {
            yield assignReferrer({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": ciam_token,
                },
                path: {
                    uuid,
                },
                body: {
                    referrer_code,
                    source: source !== null && source !== void 0 ? source : undefined,
                },
            });
            return true;
        });
    }
}
//# sourceMappingURL=ReferralApiEvo.js.map